import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';
import { MaskitoDirective } from '@maskito/angular';

import { ErrorMessageDirective } from '../../misc/directives/error-message.directive';
import { RequiredDirective } from '../../misc/directives/required.directive';
import { MiscModule } from '../../misc/misc.module';
import { AdvancedPageRoutingModule } from './advanced-routing.module';
import { AdvancedPageComponent } from './advanced.page';

@NgModule({
  declarations: [AdvancedPageComponent],
  imports: [
    CommonModule,
    IonicModule,
    AdvancedPageRoutingModule,
    ReactiveFormsModule,
    MiscModule,
    MaskitoDirective,
    ErrorMessageDirective,
    RequiredDirective
  ]
})
export class AdvancedPageModule {}
